import type { ImportHistoryItem } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';

import { useImportBlobDownload } from './use-import-blob-download';

// ─── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Downloads an import row's original uploaded file (no `fetch` — the server pins
 * `Content-Disposition: attachment`, including the original filename, into the signed URL).
 */
export function useDownloadImportFile(): UseMutationResult<void, Error, ImportHistoryItem> {
  return useImportBlobDownload((api, importDoc) => api.downloadImportFile(importDoc.id), 'history.downloadError');
}
